<template>
	<LayoutOffcanvasStandard ref="offcanvas" title="Registrar pago" id="company-admin-balance-payment">
		<template #body v-if="balance">
			<div class="alert bg-secondary text-white hstack gap-2 rounded-pill ps-2 pe-3 py-1 lh-sm" role="alert">
				<i class="bi bi-info-circle"></i>
				<div class="text-sm">
					<b>{{ balance.user.name }}</b> posee un balance de <b>{{ vueNumberFormat(balance.amount, { suffix: ` ${balance.currency}`, precision: 2 }) }}</b>.
				</div>
				<a href="javascript:void(0);" class="text-reset ms-auto stretched-link" @click="form.amount = balance.amount">
					<i class="bi bi-input-cursor-text"></i>
				</a>
			</div>
			<CommonFormInputAmount v-model="form.amount" title="Monto" :subtitle="`En <b>${balance?.currency}</b>`" placeholder="Ingresar monto" />
			<CommonFormInputTextarea v-model="form.observations" title="Observaciones" subtitle="Opcional" info="Estas observaciones podrán ser vistas por el vendedor." placeholder="Ingrese una observación" />
		</template>
		<template #footer>
			<button type="button" class="btn rounded-pill w-100 btn-primary" :disabled="submitting" @click="invite">Guardar</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, reactive, onMounted } from 'vue';
	import composableForm from '@/composables/form';
	import CompanyAdminBalanceRepository from '@/repositories/modules/Company/Admin/Balance';

	export default {
		emits: ['reload'],
		setup(props, { emit }) {
			const { submitting, catchError } = composableForm();
			const offcanvas = ref(null);
			const balance = ref(null);

			const form = reactive({
				amount: null,
				observations: null
			});

			const invite = async () => {
				if(submitting.value) return;
				submitting.value = true;

				await CompanyAdminBalanceRepository.payment(balance.value.id, form).then((response) => {
					emit('reload');
					offcanvas.value.offcanvas.hide();
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const show = (dataBalance) => {
				balance.value = dataBalance;
				form.amount = null;
				form.observations = null;
				offcanvas.value.offcanvas.show();
			}

			onMounted(async () => {
				document.getElementById('company-admin-balance-payment').addEventListener('shown.bs.offcanvas', () => {
					document.querySelector('#company-admin-balance-payment input').focus();
				});
			});

			return { offcanvas, form, invite, show, submitting, balance };
		}
	}
</script>